/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DebugJobAction = {
    timeout?: number;
    type: DebugJobAction.type;
};

export namespace DebugJobAction {

    export enum type {
        TEST_CONNECTION = 'TEST_CONNECTION',
    }


}
